import api from "components/settings/api";

let skillList = [
  { skill: "JavaScript" },
  { skill: "Node.Js" },
  { skill: "React" },
  { skill: "React Native" },
  { skill: "Angular" },
  { skill: "Calculus" },
  { skill: "Geometry" },
  { skill: "Statistics" },
  { skill: "Quantitative Analysis" },
  { skill: "Vue.Js" },
  { skill: "Socket.io" },
  { skill: "Python 3" },
  { skill: "Python 2" },
  { skill: "C#" },
  { skill: "C++" },
  { skill: "Objective C" },
  { skill: "Deno" },
  { skill: "Chemistry" },
  { skill: "Biology" },
  { skill: "Ecology" },
  { skill: "Geology" },
  { skill: "Flutter" },
  { skill: "Dart" },
  { skill: "Docker" },
  { skill: "Kubernetes" },
  { skill: "Express" },
  { skill: "SQL" },
  { skill: "MySQL" },
  { skill: "MongoDB" },
  { skill: "Mongoose.Js" },
  { skill: "HTML" },
  { skill: "Physics" },
  { skill: "Astronomy" },
  { skill: "CSS" },
  { skill: "C " },
  { skill: "Go" },
  { skill: "Java" },
  { skill: "Oceanography" },
  { skill: "Sociology" },
  { skill: "Anthropology" },
  { skill: "History" },
  { skill: "Scala" },
  { skill: "Trivia" },
  { skill: "Tests" },
  { skill: "Tutoring" },
  { skill: "Scala" },
  { skill: "Accounting" },
  { skill: "Project Managment" },
  { skill: "Organization Skills" },
  { skill: "Gaming" },
  { skill: "DevOps" },
  { skill: "Computer Skills" },
  { skill: "Office 365" },
  { skill: "Google IT certification" },
  { skill: "Sports" },
  { skill: "Typist" },
  { skill: "Blogger" },
  { skill: "Journalism" },
  { skill: "Science" },
  { skill: "Math" },
  { skill: "Foreign Languages" },
  { skill: "Economics" },
  { skill: "Creative Writing" },
  { skill: "Actor" },
  { skill: "Comedy" },
  { skill: "Instructor" },
  { skill: "Criminal Justice" },
  { skill: "Entrepreneur" },
  { skill: "Data Engineer" },
  { skill: "Mechanical Engineer" },
  { skill: "Electrical Engineer" },
  { skill: "Medical Engineer" },
  { skill: "Structual Engineer" },
];
  api.get("/api/v1/profiles/skills").then(item=>{
  skillList=item
  ;
});

export const options = skillList.sort((a, b) => a.skill.localeCompare(b.skill));

export default options;